import {PLATFORM_AREA, COMPONENT_ID, RIA_COMPONENT} from '@advisor/util/constants';
import AdvCommonUtilMethods from '@advisor/util/AdvCommonUtilMethods';

// eslint-disable-next-line require-await
export default [
  {
    // Documentss entry point
    path: '/advisor/documents',
    name: 'Documents',
    component: () => import('@advisor/components/settings/ManageDocuments'),
    props: true,
    meta: {
      breadCrumbs: {
        to: '',
        text: 'Settings',
        title: 'Documents',
        componentId: COMPONENT_ID.DOCUMENTS,
      },
      platformArea: PLATFORM_AREA.DOCUMENTS,
      riaComponent: RIA_COMPONENT.DOCUMENTS,
      visibilityComponentId: COMPONENT_ID.DOCUMENTS,
    },
  },
  {
    // create new workflow
    path: '/advisor/documents/workflow/add',
    name: 'AddWorkflow',
    component: () => import('@advisor/components/settings/documents/WorkflowForm'),
    meta: {
      platformArea: PLATFORM_AREA.DOCUMENTS,
      riaComponent: RIA_COMPONENT.DOCUMENTS,
      visibilityComponentId: COMPONENT_ID.DOCUMENTS,
    },
    beforeEnter: (to, from, next) => AdvCommonUtilMethods.clientViewOnlyCheck(to, from, next),
  },
  {
    // create edit workflow
    path: '/advisor/documents/workflow/:wfId/edit',
    name: 'EditWorkflow',
    component: () => import('@advisor/components/settings/documents/WorkflowForm'),
    meta: {
      platformArea: PLATFORM_AREA.DOCUMENTS,
      riaComponent: RIA_COMPONENT.DOCUMENTS,
      visibilityComponentId: COMPONENT_ID.DOCUMENTS,
    },
    beforeEnter: (to, from, next) => AdvCommonUtilMethods.clientViewOnlyCheck(to, from, next),
  },
];
